import * as R from 'ramda';

export const mapPaginatedResultFromJson = R.curry((dataMapper, json) =>
  (json => ({
    currentPage: +R.pathOr(1, ['pagination', 'current_page'], json),
    currentLimit: +R.pathOr(10, ['pagination', 'current_limit'], json), // Items per page
    total: +R.pathOr(1, ['pagination', 'total'], json), // last_page
    data: R.defaultTo([], json['data']).map(dataMapper)
  }))(R.defaultTo({}, json))
);
